import React from "react";
import "./HomePage.scss";
import {
  RespondentsOverviewSection,
  MessageFromPresidentSection,
  AboutSection,
  FederalReductionsSection,
  ServiceProvidersSection,
  OrganizationalAdaptationsSection,
  FoundationAdaptationsSection,
  TrendingTechSection,
  DataStrategicMessagingSection,
  InnovationInPracticeSection,
  InnovationLatinoCoalitionSection,
  TrendingTechHighlights,
  RecommendationsSection,
  ClosingThoughtsSection,
  AboutNRWCSection,
} from "../sections";
import HeroSection from "./HeroSection";

const HomePage: React.FC = () => {
  return (
    <div className="home-page">
      <HeroSection
        title="2025 STATE OF THE REENTRY WORKFORCE"
        subtitle="Navigating Uncertainty in the Field"
      />

      <MessageFromPresidentSection />

      <AboutSection />

      <RespondentsOverviewSection />

      <FederalReductionsSection />

      <ServiceProvidersSection />

      <InnovationLatinoCoalitionSection />

      <OrganizationalAdaptationsSection />

      <FoundationAdaptationsSection />

      <TrendingTechSection />

      <TrendingTechHighlights />

      <DataStrategicMessagingSection />

      <InnovationInPracticeSection />

      <RecommendationsSection />

      <ClosingThoughtsSection />

      <AboutNRWCSection />

      {/* NOTE: DashboardSection Contains a bunch of charts that we are not using in the report but they do pull directly from the data */}
      {/* <DashboardSection />  */}
    </div>
  );
};

export default HomePage;
